module.exports = __webpack_public_path__ + "static/media/Logo.9e62ae43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo.svg
// module id = 699
// module chunks = 4